import AccountType from './AccountType';

const AccountTypeDescription = ['平台账号', '客户账号', '平台子账号', '客户子账号'];
export default class EnumDesription {
  static getAccountTypeDescription(accountType: AccountType):string {
    return AccountTypeDescription[accountType];
  }
}
